import CheckoutComponentReducers from 'yoda-checkout-components/lib/reducers';
// Temp fix for MCYODA-13025 until itemcountreducer to be added in site components reducers/index.js
import ItemCountReducer from 'yoda-site-components/lib/reducers/ItemCountReducer';
import CouponsReducer from 'yoda-site-components/lib/reducers/CouponsReducer';
import SessionReducer from 'yoda-site-components/lib/reducers/SessionReducer';
import AppliedAdjustmentsReducer from 'yoda-site-components/lib/reducers/AppliedAdjustmentsReducer';
import UpdatedAdjustmentReducer from 'yoda-site-components/lib/reducers/UpdatedAdjustmentReducer';
import MessagesReducer from 'yoda-site-components/lib/reducers/MessagesReducer';
import WebvitalsReducer from 'yoda-site-components/lib/reducers/WebvitalsReducer';

import SYFQuickScreenReducer from 'yoda-account-components/lib/reducers/SYFQuickScreenReducer';
import OrderConfirmationReducer from './OrderConfirmationReducer';
import CreateAccountPostOrderReducer from './CreateAccountPostOrderReducer';
import CreateSessionPostOrderReducer from './CreateSessionPostOrderReducer';
import ExpressCheckoutReducer from './ExpressCheckoutReducer';
import OrderInfoReducer from './OrderInfoReducer';
import OrderBillingInfoReducer from './OrderBillingInfoReducer';
import OrderShippingGroupsInfoReducer from './OrderShippingGroupsInfoReducer';
import OrderGiftWrapInfoReducer from './OrderGiftWrapInfoReducer';
import OrderContactInfoReducer from './OrderContactInfoReducer';
import OrderItemsReducer from './OrderItemsReducer';
import OrderTotalsReducer from './OrderTotalsReducer';
import OrderAdjustmentsReducer from './OrderAdjustmentsReducer';
import OrderChargesReducer from './OrderChargesReducer';
import OrderPaymentInfoReducer from './OrderPaymentInfoReducer';
import StoreInfoReducer from './StoreInfoReducer';
import CertonaAttributesReducer from './CertonaAttributesReducer';
import ItemDeliverySummaryReducer from './ItemDeliverySummaryReducer';
import ShippingAddressFormReducer from './ShippingAddressFormReducer';
import CheckoutPageReducer from './CheckoutPageReducer';
import CheckoutSectionReducer from './CheckoutSectionReducer';
import PaymentReducer from './PaymentReducer';
import AlternateChargeReducer from './AlternateChargeReducer';
import NewPaymentReducer from './NewPaymentReducer';
import NewBOPISReducer from './NewBOPISReducer';
import NewShippingReducer from './NewShippingReducer';
import BNPLSectionReducer from './BNPLSectionReducer';

const rootReducer = {
    expressCheckoutInfo: ExpressCheckoutReducer,
    checkoutInfo: CheckoutSectionReducer,
    orderDetails: OrderConfirmationReducer,
    orderInfo: OrderInfoReducer,
    orderBillingInfo: OrderBillingInfoReducer,
    orderShippingGroupsInfo: OrderShippingGroupsInfoReducer,
    orderGiftWrapInfo: OrderGiftWrapInfoReducer,
    orderContactInfo: OrderContactInfoReducer,
    orderItems: OrderItemsReducer,
    orderTotals: OrderTotalsReducer,
    orderAdjustments: OrderAdjustmentsReducer,
    orderCharges: OrderChargesReducer,
    orderPaymentInfo: OrderPaymentInfoReducer,
    createAccountPostOrderData: CreateAccountPostOrderReducer,
    createSessionPostOrderData: CreateSessionPostOrderReducer,
    storeDetails: StoreInfoReducer,
    certonaAttributesData: CertonaAttributesReducer,
    itemDeliverySummary: ItemDeliverySummaryReducer,
    shippingAddressForm: ShippingAddressFormReducer,
    checkoutPage: CheckoutPageReducer,
    payment: PaymentReducer,
    bagItemCount: ItemCountReducer,
    alternateChargeInfo: AlternateChargeReducer,
    bnplSectionData: BNPLSectionReducer,
    isCheckout: () => true,
    newPayment: NewPaymentReducer,
    newShipping: NewShippingReducer,
    newBOPIS: NewBOPISReducer,
    syfQuickScreen: SYFQuickScreenReducer,
    /**
     * BOF get coupon
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     */
    coupons: CouponsReducer,
    /**
     * find stores
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShipToHomeOrBopisOption/ShipToHomeOrBopisOption.jsx
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShowDetailedFulfillments/ShowDetailedFulfillments.jsx
     * yoda-microsite-checkout/src/sagas/ShipToStoreSaga.js - in microsite
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/GeneralInformation/GeneralInformation.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     */
    /**
     * session management
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/components/SingleClickCheckoutWrapper/SingleClickCheckoutWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/SignIn/SignInPage.jsx
     * yoda-microsite-checkout/src/LazyModules/LazyModules.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewPaymentPage/NewPaymentPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/OrderConfirmation/OrderConfirmationPage.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    session: SessionReducer,
    /**
     * get applied coupon
     * yoda-site-components/src/sagas/AdjustmentSaga.js (coupon, cart, checkout, coupon drawer)
     * yoda-microsite-marketing/src/containers/Pages/Marketing/Marketing.jsx
     * Coupon drawer
     * Coupon page IRIS component "couponlist"
     */
    appliedAdjustments: AppliedAdjustmentsReducer,
    /**
     * get adjustment update status
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-site-components/src/sagas/AdjustmentSaga.js (coupon, cart, checkout, coupon drawer)
     * Coupon page IRIS component "couponlist"
     * Coupon drawer
     */
    isAdjustmentsUpdated: UpdatedAdjustmentReducer,
    /**
     * messages on various pages
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * Coupon drawer
     * Coupon page IRIS component "couponlist"
     */
    messages: MessagesReducer,
    webvitals: WebvitalsReducer,
    ...CheckoutComponentReducers,
};

export default rootReducer;
